import * as React from 'react';

import './RadioButton.scss';

interface ICheckboxProps {
  name: string;
  value: string;
  checked: boolean;
  className?: string;
  extraText?: string;
  onChange: (e: any) => void;
}

class Checkbox extends React.Component<ICheckboxProps, any> {
  public render() {
    return (
      <label
        className={`rp-radio-button ${this.props.checked &&
          'rp-radio-checked'} ${
          this.props.className ? this.props.className : ''
        }`}
      >
        <input
          type="radio"
          name={this.props.name}
          value={this.props.value}
          checked={this.props.checked}
          onChange={this.props.onChange}
          className="rp-radio-button--input"
        />
        <span
          className={`${
            this.props.checked
              ? 'rpds-radio-button-checked'
              : 'rpds-radio-button-unchecked'
          } radio-icon`}
        />
        <div className="rp-radio-button--text">
          <div>{this.props.extraText}</div>
          <div>{this.props.name}</div>
        </div>
      </label>
    );
  }
}

export default Checkbox;
